import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-xmark" }, null, -1)
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-xmark" }, null, -1)
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { class: "card h-100" }
const _hoisted_8 = { class: "card-body d-flex justify-content-center text-center flex-column p-8" }
const _hoisted_9 = { class: "text-gray-800 text-hover-primary d-flex flex-column" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-60px mb-5" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/metronic8/demo1/assets/media/svg/files/pdf.svg",
    class: "theme-light-show",
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: "/metronic8/demo1/assets/media/svg/files/pdf-dark.svg",
    class: "theme-dark-show",
    alt: ""
  })
], -1)
const _hoisted_11 = { class: "fs-5 fw-bold mb-2" }
const _hoisted_12 = { class: "fs-7 fw-semibold text-gray-400" }
const _hoisted_13 = { key: 3 }
const _hoisted_14 = { class: "card h-100" }
const _hoisted_15 = { class: "card-body d-flex justify-content-center text-center flex-column p-8" }
const _hoisted_16 = { class: "text-gray-800 text-hover-primary d-flex flex-column" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-60px mb-5" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/metronic8/demo1/assets/media/svg/files/doc.svg",
    class: "theme-light-show",
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: "/metronic8/demo1/assets/media/svg/files/doc-dark.svg",
    class: "theme-dark-show",
    alt: ""
  })
], -1)
const _hoisted_18 = { class: "fs-5 fw-bold mb-2" }
const _hoisted_19 = { class: "fs-7 fw-semibold text-gray-400" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_image = _resolveComponent("n-image")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_video_player = _resolveComponent("video-player")!

  return (_ctx.postMediaTypeId == 1)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.value.length > 0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.value, (i, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "ImagePreView col-md-3",
                  key: index
                }, [
                  _createVNode(_component_n_image, {
                    src: i.link
                  }, null, 8, ["src"]),
                  _createVNode(_component_n_space, { class: "controlImage" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_n_button, {
                        onClick: ($event: any) => (_ctx.DeleteImage(i.name)),
                        tertiary: "",
                        secondary: "",
                        circle: "",
                        type: "error"
                      }, {
                        icon: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024)
                ]))
              }), 128))
            : _createCommentVNode("", true)
        ])
      ]))
    : (_ctx.postMediaTypeId == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.value.length > 0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.value, (i, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "ImagePreView col-md-12",
                  key: index
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.value, (i, index) => {
                    return (_openBlock(), _createBlock(_component_video_player, {
                      key: index,
                      src: i.link,
                      class: "video-player-box",
                      controls: "",
                      loop: true,
                      volume: 0.6
                    }, null, 8, ["src", "volume"]))
                  }), 128)),
                  _createVNode(_component_n_space, { class: "controlImage" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_n_button, {
                        onClick: ($event: any) => (_ctx.DeleteImage(i.name)),
                        tertiary: "",
                        secondary: "",
                        circle: "",
                        type: "error"
                      }, {
                        icon: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024)
                ]))
              }), 128))
            : _createCommentVNode("", true)
        ]))
      : (_ctx.postMediaTypeId == 3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_ctx.value.length > 0)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.value, (i, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "col-md-6 col-lg-4 col-xl-3",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("a", _hoisted_9, [
                          _hoisted_10,
                          _createElementVNode("div", _hoisted_11, _toDisplayString(i.name), 1)
                        ]),
                        _createElementVNode("div", _hoisted_12, _toDisplayString(i.name), 1)
                      ])
                    ])
                  ]))
                }), 128))
              : _createCommentVNode("", true)
          ]))
        : (_ctx.postMediaTypeId == 4)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              (_ctx.value.length > 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.value, (i, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "col-md-6 col-lg-4 col-xl-3",
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("a", _hoisted_16, [
                            _hoisted_17,
                            _createElementVNode("div", _hoisted_18, _toDisplayString(i.name), 1)
                          ]),
                          _createElementVNode("div", _hoisted_19, _toDisplayString(i.name), 1)
                        ])
                      ])
                    ]))
                  }), 128))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
}